<div>
    <app-content-container [content_template]="page_content"
                           [is_loading]="is_loading"
                           [loading_text]="loading_text" [custom_class]="'no-padding'"></app-content-container>
</div>
<ng-template #page_content>
    <div class="padding">
        <div class="card card-1 padding table-wrapper" *ngIf="!is_loading && LapTimesUnconfirmed">
            <app-fb-forms-table [storeObj]="LapTimesUnconfirmed"
                                [edit_allowed]="false"
                                [storeExtObj]="custom_obj"
                                (row_click)="rowSelected($event)"
                                [stateKey]="'lap-times-unconfirmed'"
                                [show_add]="false"
                                [show_delete]="is_admin"
                                [title]="'New best unconfirmed Lap Times'"
            >
            </app-fb-forms-table>
        </div>
    </div>
</ng-template>
<ng-template #select_caption_tpl let-element="element" let-column="column">
    {{element.tmp.caption[column.id]}}
</ng-template>
